import { render, staticRenderFns } from "./VariantBudgetTemplate.vue?vue&type=template&id=1354e6d9&"
import script from "./VariantBudgetTemplate.vue?vue&type=script&lang=ts&"
export * from "./VariantBudgetTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports